import React, { Component } from 'react';
import { Table, Button } from 'antd';
import { PlusOutlined, PrinterOutlined } from '@ant-design/icons';
import moment from 'moment';

export class RangeDetail extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        
    }

    render() {
        return (
            <div className="">
                ahihi
            </div>
        )
    }
}